if (!customElements.get('editorial-collection-list')) {
  customElements.define(
    'editorial-collection-list',
    class EditorialCollectionList extends HTMLElement {
      constructor() {
        super();
        this.activate = this.activate.bind(this);
        this.activeIndex = null;
      }

      connectedCallback() {
        this.rows = Array.from(this.querySelectorAll('.editorial-cl__row-link'));
        this.mediaItems = Array.from(this.querySelectorAll('.editorial-cl__media-item'));

        this.rows.forEach((row) => {
          row.addEventListener('mouseenter', this.activate);
          row.addEventListener('focus', this.activate);
        });
      }

      disconnectedCallback() {
        if (!this.rows) return;
        this.rows.forEach((row) => {
          row.removeEventListener('mouseenter', this.activate);
          row.removeEventListener('focus', this.activate);
        });
      }

      activate(event) {
        const index = event.currentTarget.dataset.index;
        if (index === this.activeIndex) return;
        this.activeIndex = index;

        this.rows.forEach((row) => {
          row.classList.toggle('is-active', row.dataset.index === index);
        });

        this.mediaItems.forEach((item) => {
          const isActive = item.dataset.index === index;
          item.classList.toggle('is-active', isActive);
          if (isActive) {
            item.removeAttribute('aria-hidden');
          } else {
            item.setAttribute('aria-hidden', 'true');
          }
        });
      }
    }
  );
}
